import { loadMessages as webconsumernav } from "@snapchat/web-consumer-nav/i18n/messageLoader";
import { loadMessages as webcoreui } from "@snapchat/web-core-ui/i18n/messageLoader";
import { loadMessages as weblivelens } from "@snapchat/web-live-lens/i18n/messageLoader";
import { loadMessages as webnocontentpage } from "@snapchat/web-no-content-page/i18n/messageLoader";
import { loadMessages as websharing } from "@snapchat/web-sharing/i18n/messageLoader";
export async function loadLibraryMessages(locale) {
    return {
        ...(await webconsumernav(locale)),
        ...(await webcoreui(locale)),
        ...(await weblivelens(locale)),
        ...(await webnocontentpage(locale)),
        ...(await websharing(locale)),
    };
}
